import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "navigationPreviewButtonSelector",
    "navigationPreviewButtonIcon",
    "navigationPreviewButtonText",
    "previewButton",
    "refreshBackground",
    "refreshIcon",
    "refreshText",
    "previewIframe",
    "logoPreview",
    "backgroundPreview",
    "secondaryBrandingSection",
  ];

  changeNavigationButtonColor(event) {
    this.navigationPreviewButtonSelectorTarget.style.backgroundColor = event.target.value;
    this.navigationPreviewButtonIconTarget.style.color = event.target.value;
    this.navigationPreviewButtonTextTarget.style.color = event.target.value;
  }

  changeButtonColor(event) {
    this.previewButtonTargets.forEach((button) => {
      button.style.backgroundColor = event.target.value;
    });
    this.postMessageToIframe("button_color", event.target.value);
  }

  changeButtonTextColor(event) {
    this.previewButtonTargets.forEach((button) => {
      button.style.color = event.target.value;
    });
    this.postMessageToIframe("button_text_color", event.target.value);
  }

  changeSecondaryButtonColor(event) {
    this.postMessageToIframe("secondary_button_color", event.target.value);
  }

  changeSecondaryButtonTextColor(event) {
    this.postMessageToIframe("secondary_button_text_color", event.target.value);
  }

  toggleSecondaryBranding(event) {
    const enabled = event.target.value === "true";

    if (this.hasSecondaryBrandingSectionTarget) {
      this.secondaryBrandingSectionTarget.classList.toggle("hidden", !enabled);
    }

    if (enabled) {
      const section = this.secondaryBrandingSectionTarget;
      const colorInput = section?.querySelector(
        'input[name="customer_portal[secondary_button_color]"]'
      );
      const textInput = section?.querySelector(
        'input[name="customer_portal[secondary_button_text_color]"]'
      );
      if (colorInput) this.postMessageToIframe("secondary_button_color", colorInput.value);
      if (textInput) this.postMessageToIframe("secondary_button_text_color", textInput.value);
    } else {
      this.postMessageToIframe("secondary_reset", "");
    }
  }

  changeBackgroundColor(event) {
    if (this.hasRefreshBackgroundTarget) {
      this.refreshBackgroundTarget.style.backgroundColor = event.target.value;
    }
    this.postMessageToIframe("background_color", event.target.value);
    this.backgroundPreviewTarget.style.backgroundColor = event.target.value;
  }

  changeIconColor(event) {
    if (this.hasRefreshIconTarget) {
      this.refreshIconTargets.forEach((icon) => {
        icon.style.color = event.target.value;
      });
    }
    if (this.hasRefreshTextTarget) {
      this.refreshTextTargets.forEach((text) => {
        text.style.color = event.target.value;
      });
    }
    this.postMessageToIframe("icon_color", event.target.value);
  }

  postMessageToIframe(property, value) {
    if (this.hasPreviewIframeTarget) {
      this.previewIframeTarget.contentWindow?.postMessage(
        {
          type: "colorUpdate",
          property: property,
          value: value,
        },
        "*"
      );
    }
  }

  connect() {
    document.addEventListener("turbo:submit-end", (event) => {
      if (event.detail.success && this.hasPreviewIframeTarget) {
        setTimeout(() => {
          this.refreshIframe();
        }, 500);
      }
    });
  }

  refreshIframe() {
    if (this.hasPreviewIframeTarget) {
      const currentSrc = this.previewIframeTarget.src;
      const separator = currentSrc.includes("?") ? "&" : "?";
      this.previewIframeTarget.src = currentSrc + separator + "_refresh=" + Date.now();
    }
  }

  previewLogo(event) {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const imageDataUrl = e.target.result;

        if (this.hasLogoPreviewTarget) {
          this.logoPreviewTarget.src = imageDataUrl;
        }

        this.postMessageToIframe("logo_url", imageDataUrl);
      };
      reader.readAsDataURL(file);
    }
  }
}
